import { c as _c } from "react/compiler-runtime";
import { useMonth } from '@datepicker-react/hooks';
import PropTypes from 'prop-types';
import Day from './Day';
function Month(t0) {
  const $ = _c(20);
  const {
    year,
    month,
    firstDayOfWeek,
    locale
  } = t0;
  let t1;
  if ($[0] !== locale) {
    t1 = new Intl.DateTimeFormat(locale, {
      weekday: "short"
    });
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const weekdayLabelFormatter = t1;
  let t2;
  if ($[2] !== weekdayLabelFormatter) {
    t2 = date => weekdayLabelFormatter.format(date);
    $[2] = weekdayLabelFormatter;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== firstDayOfWeek || $[5] !== month || $[6] !== t2 || $[7] !== year) {
    t3 = {
      year,
      month,
      firstDayOfWeek,
      weekdayLabelFormat: t2
    };
    $[4] = firstDayOfWeek;
    $[5] = month;
    $[6] = t2;
    $[7] = year;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    days,
    weekdayLabels
  } = useMonth(t3);
  let t4;
  if ($[9] !== weekdayLabels) {
    t4 = weekdayLabels.map(_temp);
    $[9] = weekdayLabels;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <div className="grid grid-cols-7">{t4}</div>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== days) {
    t6 = days.map(_temp2);
    $[13] = days;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <div className="grid grid-cols-7 gap-y-2">{t6}</div>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <div className="mx-auto w-[280px]" data-testid="month-calendar">{t5}{t7}</div>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function _temp2(day, i) {
  return <Day key={`${day.date}-${i}`} date={day.date} day={day.dayLabel} />;
}
function _temp(dayLabel) {
  return <div className="w-10 mb-1 text-center typography-caption-1 text-neutral-700" key={dayLabel}>{dayLabel}</div>;
}
Month.propTypes = {
  year: PropTypes.number.isRequired,
  month: PropTypes.number.isRequired,
  firstDayOfWeek: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired
};
export default Month;